/** @format */

import { Route } from "react-router-dom";
import AgentRootBeforeRender from "../pages/common/AgentRootBeforeRender";
import RedirectBeforeRender from "../pages/common/RedirectBeforeRender";
import BeforeRender from "../pages/common/BeforeRender";

import { OcnkTeikiEntryColumn } from "../components/ui_elements/ocnkTeiki/Entry/EntryColumn";

// 共通ページ
import Login from "../pages/common/Login";
import ResetPassword from "../pages/common/ResetPassword";
import ResetPasswordMail from "../pages/common/ResetPasswordMail";
import ResetPasswordMailCompleted from "../pages/common/ResetPasswordMailCompleted";
import ChangePasswordMail from "../pages/common/ChangePasswordMail";
import EntrySelect from "../pages/ocnkTeiki/EntrySelect";
import SystemError from "../pages/common/SystemError";
import RedirectTimeout from "../pages/common/RedirectTimeout";

import UserRegisterAuthentication from "../pages/ocnk/UserRegisterAuthentication";
import DashBoard from "../pages/ocnkTeiki/DashBoard";
import EconomicEstimate from "../pages/ocnkTeiki/EconomicEstimate";
import EconomicEstimateCheck from "../pages/ocnkTeiki/EconomicEstimateCheck";
import OcnkTeikiEntryTop from "../pages/ocnkTeiki/EntryTop";
import OcnkTeikiEntry from "../pages/ocnkTeiki/Entry";

import OcnkTeikiRedirectPassword from "../pages/ocnkTeiki/RedirectPassword";
import OcnkTeikiRedirectEconomic from "../pages/ocnkTeiki/RedirectEconomic";

import EntryConfirm from "../pages/ocnkTeiki/EntryConfirm";
import EntryCompleted from "../pages/ocnkTeiki/EntryCompleted";
import EntryCheck from "../pages/ocnkTeiki/EntryCheck";
import UseStart from "../pages/ocnkTeiki/UseStart";
import ExaminationStatus from "../pages/ocnkTeiki/ExaminationStatus";
import UseStartPrecautions from "../pages/ocnk/UseStartPrecautions";
import Inquiry from "../pages/ocnk/Inquiry";

const OcnkSubscriptionRouting = [
  <Route path="ocnk_subscription" element={<AgentRootBeforeRender agentPath="/ocnk_subscription" />}>
    <Route path="login" element={<BeforeRender Component={Login} IsLoggedIn={false} />} />
    <Route path="reset_password_mail" element={<BeforeRender Component={ResetPasswordMail} IsLoggedIn={false} />} />
    <Route
      path="reset_password_mail_completed"
      element={<BeforeRender Component={ResetPasswordMailCompleted} IsLoggedIn={false} />}
    />
    <Route path="reset_password" element={<BeforeRender Component={ResetPassword} IsLoggedIn={false} />} />
    <Route path="system_error" element={<BeforeRender Component={SystemError} IsLoggedIn={false} />} />
    <Route path="redirect_timeout" element={<BeforeRender Component={RedirectTimeout} IsLoggedIn={false} />} />
    <Route
      path="user_register_auth"
      element={<BeforeRender Component={UserRegisterAuthentication} IsLoggedIn={false} />}
    />
    <Route path="entry_select" element={<BeforeRender Component={EntrySelect} IsLoggedIn={false} />} />
    <Route path="change_password_mail" element={<BeforeRender Component={ChangePasswordMail} />} />
    <Route path="dashboard" element={<BeforeRender Component={DashBoard} />} />
    <Route path="economic_estimate" element={<BeforeRender Component={EconomicEstimate} />} />
    <Route path="economic_estimate_check" element={<BeforeRender Component={EconomicEstimateCheck} />} />
    <Route
      path="redirect/economic_estimate_check"
      element={<RedirectBeforeRender Component={EconomicEstimateCheck} redirect={true} />}
    />
    <Route path="entry_top" element={<BeforeRender Component={OcnkTeikiEntryTop} />} />
    <Route path="entry" element={<BeforeRender Component={OcnkTeikiEntry} />}>
      <Route path="merchant" element={<OcnkTeikiEntryColumn path="merchant" />} />
      <Route path="bank_account" element={<OcnkTeikiEntryColumn path="bank_account" />} />
      <Route path="shop" element={<OcnkTeikiEntryColumn path="shop" />} />
    </Route>
    <Route
      path="redirect_economic_estimate"
      element={<RedirectBeforeRender Component={OcnkTeikiRedirectEconomic} redirect={true} />}
    />
    <Route path="redirect" element={<RedirectBeforeRender Component={OcnkTeikiEntry} redirect={true} />}>
      <Route path="merchant" element={<OcnkTeikiEntryColumn path="merchant" redirect={true} />} />
      <Route path="bank_account" element={<OcnkTeikiEntryColumn path="bank_account" redirect={true} />} />
      <Route path="shop" element={<OcnkTeikiEntryColumn path="shop" redirect={true} />} />
    </Route>
    <Route
      path="redirect_password"
      element={<RedirectBeforeRender Component={OcnkTeikiRedirectPassword} redirect={true} />}
    />
    <Route path="redirect_confirm" element={<RedirectBeforeRender Component={EntryConfirm} redirect={true} />} />
    <Route path="redirect_completed" element={<RedirectBeforeRender Component={EntryCompleted} />} />
    <Route path="entry_confirm" element={<BeforeRender Component={EntryConfirm} />} />
    <Route path="entry_completed" element={<BeforeRender Component={EntryCompleted} />} />
    <Route path="entry_check" element={<BeforeRender Component={EntryCheck} />} />
    <Route path="use_start" element={<BeforeRender Component={UseStart} />} />
    <Route path="examination_status" element={<BeforeRender Component={ExaminationStatus} />} />
    <Route path="use_start_precautions" element={<BeforeRender Component={UseStartPrecautions} />} />
    <Route path="inquiry" element={<BeforeRender Component={Inquiry} />} />
  </Route>,
];

export default OcnkSubscriptionRouting;
